/**
 * Resolves the items array from GET information/get/all JSON.
 * Supports { data: Item[] } and { data: { data: Item[], total?: number } }.
 */
export function getInformationListFromResponse(apiJson) {
  const payload = apiJson?.data;
  if (Array.isArray(payload)) return payload;
  if (payload && Array.isArray(payload.data)) return payload.data;
  return [];
}
